import {SET_COUPONS} from '../constants/coupons';
import couponsAPI from '../../_api/coupons';

const setCoupons = list => ({type: SET_COUPONS, list});

export const getCoupons = () => async (dispatch) => {
  const response = await couponsAPI.getList();
  if (response) dispatch(setCoupons(response.results));
};
